<template>
    <div :id="`rating-${productId}`" class="addRating" :class="size ? `addRating--${size} ` : ''">
        <span
            v-for="(rate, index) in new Array(5)"
            :key="index"
            class="addRating__item"
            :class="{ 'addRating__item--rated': rating >= index + 1 }"
            @click="$emit('setRating', index + 1, rateId)"
        >
            <span class="addRating__item__skeleton" :style="`width: ${Math.round(Math.min(100, Math.max(0, (rating - index) * 100)))}%`" />
        </span>
    </div>
</template>

<script lang="ts">
export default {
    props: {
        rating: {
            type: Number,
            default: 0,
        },
        rateId: {
            type: Number,
            default: 0,
        },
        productId: {
            type: Number,
            default: 0,
        },
        size: {
            type: String,
            default: 'default',
        },
    },
    emits: ['setRating'],
}
</script>

<style lang="scss" scoped>
.addRating {
    display: flex;
    gap: 7px;
    justify-content: space-between;
    margin-top: 10px;
    @media (min-width: 992px) {
        margin-top: 0;
        gap: 5px;
    }

    &:hover .addRating__item {
        background-color: $color-purple;
        transition-delay: 450ms;
        transition: all 450ms;
    }

    &__item {
        width: 20%;
        height: 30px;
        background-color: $color-grey;
        border-radius: $rounded;
        cursor: pointer;
        transition-delay: 450ms;
        transition: all 450ms;
        @media (min-width: 992px) {
            height: 14px;
        }

        &:hover ~ .addRating__item {
            background-color: $color-grey;
        }

        &--rated {
            background-color: $color-purple;
        }

        &__skeleton {
            height: 30px;
            border-radius: $rounded;
            background-color: $color-purple;
        }
    }

    &:hover .addRating__item {
        background: transparent url('/nuxt-assets/images/icons/star-activate.svg') no-repeat 0 0;
        background-size: 24px 24px;
    }

    .addRating__item {
        width: 24px;
        height: 24px;
        background: transparent url('/nuxt-assets/images/icons/star-deactivate.svg') no-repeat 0 0;
        background-size: 24px 24px;

        &--rated {
            background: transparent url('/nuxt-assets/images/icons/star-activate.svg') no-repeat 0 0;
            background-size: 24px 24px;
        }
    }

    .addRating__item:hover ~ .addRating__item {
        background: transparent url('/nuxt-assets/images/icons/star-deactivate.svg') no-repeat 0 0;
        background-size: 24px 24px;
    }

    .addRating__item__skeleton {
        background: transparent url('/nuxt-assets/images/icons/star-activate.svg') no-repeat 0 0;
        background-size: 24px 24px;
    }
}
</style>
